import { yupResolver } from '@hookform/resolvers/yup';

import {
  email,
  object,
  REQUIRED_MESSAGE,
  string, boolean,
} from './general';

const login = object().shape({
  email: email().required(REQUIRED_MESSAGE),
  password: string().required(REQUIRED_MESSAGE),
  rememberMeToken: boolean(),
});
const firstLogin = object().shape({
  email: email().required(REQUIRED_MESSAGE),
  accessCode: string().required(REQUIRED_MESSAGE),
});

export default {
  login: yupResolver(login),
  firstLogin: yupResolver(firstLogin),
};
